export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    setting: {
        logic: []
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game'],
        linkOnly: true
    },
    lang: {
        name: 'Include Nested Games',
        category: 'BGG',
        description: 'Include nested game player counts when filtering.',
        summarise: {
            template: {
                yes: 'Including nested games',
                no: 'Not including nested games'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['count.nested']
    }
}